module.exports = __webpack_public_path__ + "img/info.a2a0266a.svg";